module.exports = {"510131001":"鹤山街道","510131101":"大塘镇","510131102":"寿安镇","510131103":"朝阳湖镇","510131104":"西来镇","510131105":"大兴镇","510131106":"甘溪镇","510131107":"成佳镇","510131200":"复兴乡","510131201":"光明乡","510131202":"白云乡","510131203":"长秋乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510131.json
// module id = 2088
// module chunks = 0